import path from 'ramda/src/path';
import {
  SET_TYPE_PLAYER_LOCK,
  RESET_TYPE_PLAYER_LOCK,
} from '../../../constants/playerLock';

export const initialState = {
  type: null,
};

const playerLock = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TYPE_PLAYER_LOCK:
      return { ...state, type: payload };
    case RESET_TYPE_PLAYER_LOCK:
      return { ...state, type: null };
    default:
      return state;
  }
};

export default playerLock;

export const playerLockTypeSelector = (state) =>
  path(['app', 'playerLock', 'type'], state);
